import React from 'react';
import "./Search.css"
import ClockRotateLeft from './clock-rotate-left-solid-full'
import { FavIcon } from '../Decorators/Favorite';

export default function RenderSearch (props) {
  return (
    <div className="search-container">
      <input className="left-search form-control mr-sm-1" type="search" onChange={props.setSearch} value={props.filter} placeholder="Filter" aria-label="Filter" />
      <span className='tipped'>
        <span className="mrutooltip">Recently visited</span>
        <ClockRotateLeft {...props}/>
      </span>
      <span className='tipped'>
        <span className="favtooltip">Favorites</span>
        <FavIcon color='white' size="30" {...props} />
      </span>
    </div>
  );
}

